import {z} from "zod"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {extRegion} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-region/definition"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"
import {vector2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            imageOpHalOptions: imageOpHalOptions,

            sourceImage: anyImageOpResult,
            sourceWeightImage: anyImageOpResult.optional(),
            sourceRegion: extRegion.optional(), // default: {x: 0, y: 0, width: sourceImage.width, height: sourceImage.height}; offsetImage can be a 1x1 >=2-channel image; offset is added to offsetImage
            templateImage: anyImageOpResult,
            templateWeightImage: anyImageOpResult.optional(),
            templateRegion: extRegion.optional(), // default: {x: 0, y: 0, width: templateImage.width, height: templateImage.height}; offsetImage can be a 1x1 >=2-channel image; offset is added to offsetImage
            stride: vector2Like.optional().default({x: 1, y: 1}),
            options: z
                .object({
                    premultipliedImages: z.boolean().optional(), // default: false; if true, the images are assumed to be premultiplied by their weights
                })
                .optional(),
            // debugImage?: DebugImage
        }),
    },
}
